import { dashboardConstants } from '../_constants';

export function listDashboardData(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.LIST_ANALYTICS_REQUEST:
      return {
        dashboard: {
          requested: true,
          success: false,
          error: false
        }
      }
    case dashboardConstants.LIST_ANALYTICS_SUCCESS:
      return {
        dashboard: {
          requested: true,
          success: true,
          error: false
        }
      }
    case dashboardConstants.LIST_ANALYTICS_FAILURE:
      return {
        dashboard: {
          requested: true,
          success: false,
          error: true
        }
      }
    default:
      return {
        dashboard: state
      }
  }
}